import React from 'react';
import Nav from './Pages/Nav/Nav';
import { Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Route, Routes } from 'react-router-dom';
import { policyRouteLink, routerLink } from './ProtectedRoute/routes';
import ProtectedRoutes from './ProtectedRoute/ProtectedRoutes';
import PolicyRouter from './ProtectedRoute/PolicyRouter';


const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", serif', // Change this to your desired font family
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
    <Routes>
  
      
     {routerLink.map((route, i) => (
         <Route
           key={i}
           path={route.path}
           element={
             <ProtectedRoutes data={route}>
               <route.component />
             </ProtectedRoutes>
           }
         />
       ))}
        {policyRouteLink.map((route, i) => (
         <Route
           key={i}
           path={route.path}
           element={
             <PolicyRouter data={route}>
               <route.component />
             </PolicyRouter>
           }
         />
       ))}
     </Routes>
    </ThemeProvider>
  );
}

export default App;
